import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Accordion from '../../../../components/Accordion';
import Button from '../../../../components/Button';
import FormContainer from '../../../../components/FormContainer';
import Select from '../../../../components/Inputs/Select';
import StepProgress from '../../../../components/StepProgress';
import { ContainerButton, PageContainer } from '../../../../styles/styles';
import steps from '../../../../utils/steps.json';
import { useBeneficiarioEventual } from '../../../../contexts/BeneficiarioEventual/context';
import { cloneObject, downloadFile } from '../../../../utils';
import schema from './schema';
import PageLoader from '../../../../components/PageLoader';
import { ContainerDetailButton, FilterBox, FilterButton, FilterIcons, SearchedContainer, StyledDetailsContent, StyledDetailsRoute, StyledInfos, StyledModalBody, StyledTabPane, StyledTabs, StyledTittle, TableContainer, UnitiesBox, UnitiesIcons } from './styles';
import Icon from '../../../../components/Icons';
import { useGlobal } from '../../../../contexts/Global/context';
import { generateAccreditedPDF, generateProviderPDF, getServiceList, getUFCityAssistencialNetwork, obtainSpecialtyList, providerDetails, searchAssistencialNetworkList } from '../../../../services/registroAcidentados/redeAssistencial';
import Divider from '../../../../components/Divider';
import CheckboxGroup from '../../../../components/Inputs/CheckboxGroup';
import DetailModal from './DetailModal';
import DataTableMui from '../../../../components/DataTableMui';
import Input from '../../../../components/Inputs/Input';
import regexps from '../../../../utils/regexps';
import validateForm from '../../../../utils/validateForm';
import MapContainer from './MapComponent';
import Modal from '../../../../components/Modal';

function SelecionarRedeAssistencial() {
    const history = useHistory();
    const { contrastTheme } = useGlobal();
    const { dataDadosTitular } = useBeneficiarioEventual();

    const [dataForm, setDataForm] = useState(cloneObject(schema));
    const [pageLoading, setPageLoading] = useState(false);
    const [ufCity, setUfCity] = useState([]);
    const [activeTab, setActiveTab] = useState('1');
    const [regime, setRegime] = useState();
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [loading, setLoading] = useState(false);
    const [alreadySearched, setAlreadySearched] = useState(false);
    const [regionData, setRegionData] = useState([]);
    const [detailsData, setDetaisData] = useState([]);
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [especialidadesContratadas, setEspecialidadesContratadas] = useState([]);
    const [indicadorRequerEspecialidade, setIndicadorRequerEspecialidade] = useState('');
    const [selectedDistricts, setSelectedDistricts] = useState([]);
    const [initialRegionData, setInitialRegionData] = useState([]);

    const defaultMapsProps = {
        center: {
            lat: -23.2560141,
            lng: -46.0218419
        },
        zoom: 7
    };

    const columnsHead = [
        {
            key: 'registroAns',
            selector: (row) => row.registroAns || '-',
            name: 'Registro ANS',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'plano',
            selector: (row) => row.plano || '-',
            name: 'Plano',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'contratacao',
            selector: (row) => row.contratacao || '-',
            name: 'Contratação',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'situacao',
            selector: (row) => row.situacao || '-',
            name: 'Situação',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
    ]

    async function loadServiceList() {
        let serviceResponse = [];
        let treatededServiceResponse = [];
        try {
            serviceResponse = await getServiceList();
        } catch (error) {
            setPageLoading(false);
        } finally {
            treatededServiceResponse = serviceResponse ? serviceResponse.map((element) => ({
                codigo: element.codigo,
                nome: element.descricao,
                requerEspecialidade: element.indicadorRequerEspecialidade

            })) : [];

        }

        return treatededServiceResponse;
    }

    async function loadSpecialtyList(codRegime) {
        const carteirinha = dataDadosTitular.numCarteira;
        let specialtyResponse = [];
        let treatededSpecialtyResponse = [];

        try {
            specialtyResponse = await obtainSpecialtyList(codRegime, carteirinha);
        } catch (error) {
            setPageLoading(false);
        } finally {
            treatededSpecialtyResponse = specialtyResponse ? specialtyResponse.map((element) => ({
                codigo: element.codigo,
                nome: element.descricao
            })) : [];
        }

        return treatededSpecialtyResponse;
    }

    async function loadUfList(codRegime, codSpecialty) {
        const carteirinha = dataDadosTitular.numCarteira;
        const ufResponse = await getUFCityAssistencialNetwork(carteirinha, codSpecialty, codRegime);

        const uniqueUfs = [];

        ufResponse.forEach((element) => {
            const codUf = element.descricao.substring(0, 2);
            const duplicatedUfIndex = uniqueUfs.findIndex((uniqueUf) => uniqueUf.uf === codUf);

            if (duplicatedUfIndex === -1) {
                uniqueUfs.push({
                    uf: codUf,
                    codigoRegiao: element.codigo,
                    cidades: [{
                        codigo: element.codigo,
                        descricao: element.descricao
                    }]
                });
            } else {
                uniqueUfs[duplicatedUfIndex].cidades.push({
                    codigo: element.codigo,
                    descricao: element.descricao
                });
            }
        });

        setUfCity([...uniqueUfs]);

        const ufsList = uniqueUfs.map((element) => ({
            codigo: element.codigoRegiao,
            nome: element.uf
        }));

        return ufsList;
    }

    async function handleSelectChange(event) {
        const { id, value, unmaskedValue, lookup, ...rest } = event;

        let specialtyValues = {};
        let ufValues = {};
        let cityValues = {};

        const districts = cloneObject(dataForm.districts);

        if (id === 'service') {
            setPageLoading(true);
            setRegime(value);
            setIndicadorRequerEspecialidade(rest.requerEspecialidade);
            const specialtyList = (await loadSpecialtyList(value)) || [];

            specialtyValues = {
                ...dataForm,
                specialty: {
                    ...dataForm.specialty,
                    options: specialtyList,
                    required: rest.requerEspecialidade !== 'N',
                }
            }

            if (rest.requerEspecialidade === 'N') {
                const ufList = (await loadUfList(value)) || [];

                ufValues = {
                    ...dataForm,
                    uf: {
                        ...dataForm.uf,
                        options: ufList
                    }
                }
            }
        }

        if (id === 'specialty') {
            setPageLoading(true);
            const codSpecialty = value;

            const ufList = (await loadUfList(regime, codSpecialty)) || [];

            ufValues = {
                ...dataForm,
                uf: {
                    ...dataForm.uf,
                    options: ufList
                }
            }
        }

        if (id === 'uf') {
            setPageLoading(true);

            const cityFilteredByUf = ufCity ? ufCity.filter((element) => value === element.codigoRegiao) : [];

            const cities = cityFilteredByUf[0].cidades;


            const cityList = cities ? cities.map((element) => ({
                codigo: element.codigo,
                nome: element.descricao.split(' - ')[1]
            })) : [];

            cityValues = {
                ...dataForm,
                city: {
                    ...dataForm.city,
                    options: cityList
                }
            }

        }

        if (id === 'districts') {
            const selectedOptions = lookup;

            const selectedDistrictNames = selectedOptions.map(
                (option) => option.nome
            );
            setSelectedDistricts(selectedDistrictNames);
        }

        const field = {
            ...cloneObject(dataForm[id]),
            value,
            lookup,
            unmaskedValue,
            error: '',
            ...rest
        };

        setDataForm({
            ...dataForm,
            ...specialtyValues,
            ...ufValues,
            ...cityValues,
            districts,
            [id]: field,
        })
        setPageLoading(false);
    }

    function handleFilterRegions() {
        setPageLoading(true);
        const regionDataFiltered = initialRegionData.filter((region) =>
            selectedDistricts.includes(region.bairro)
        );

        if (selectedDistricts.length > 0) {
            setRegionData([...regionDataFiltered]);
        } else {
            setRegionData([...initialRegionData]);
        }
        setPageLoading(false);
    }

    useEffect(() => {
        async function loadData() {
            setPageLoading(true);
            const serviceList = (await loadServiceList()) || [];

            const initialValues = {
                ...dataForm,
                network: {
                    ...dataForm.network,
                    options: [
                        {
                            codigo: 735,
                            nome: 'Rede Médica'
                        },
                    ],

                    value: 735,
                    disabled: true,
                },
                healthPlan: {
                    ...dataForm.healthPlan,
                    options: [
                        {
                            codigo: dataDadosTitular.plano.planoSaude,
                            nome: `${dataDadosTitular.plano.planoSaude} - ${dataDadosTitular.plano.nome}`
                        }
                    ],
                    value: dataDadosTitular.plano.planoSaude,
                    disabled: true,
                },
                service: {
                    ...dataForm.service,
                    options: serviceList
                }

            };

            setDataForm({
                ...dataForm,
                ...initialValues
            });

            setPageLoading(false);
        }

        loadData();
    }, []);

    async function handleShowDetails(unityData) {
        setLoading(true);
        setPageLoading(true);

        let response = [];

        try {
            const payload = {
                descricaoPerfil: "BENEFICIARIO",
                idPrestador: unityData.codigo,
                carteirinha: dataDadosTitular.numCarteira,
                codigoEnderecoPrestador: unityData.codigoEndereco
            };

            response = await providerDetails(payload);

        } catch (error) {
            setLoading(false);
            setPageLoading(false)
        } finally {
            const data = response.detalhesPlano.map((element) => ({
                registroAns: element.numeroRegistroANS,
                plano: element.descricaoPlano,
                contratacao: element.contratacao,
                situacao: element.situacao
            }));

            const especialidades = response.especialidadesPlano.map((element) => ({
                descricaoEspecialidade: element.descricao
            }));

            setEspecialidadesContratadas([...especialidades]);
            setDetaisData([unityData]);
            setDataTable([...data]);
            setShowDetailModal(true);
            setAlreadySearched(true);
            setLoading(false);
            setPageLoading(false);
        }

    }

    function handleMapDestination() {
        const { value } = dataForm.origin;
        const destinationAdrres = detailsData[0].logradouro;

        if (!value && !destinationAdrres) {
            setShowWarningModal(true);
            setModalMessage(
                'Por gentileza, preencha com um endereço válido.'
            )
        }
        const rearangedOriginAddress = value.replaceAll(regexps.addressForGoogleMaps, '+');
        const rearangedDestinationAddres = destinationAdrres.replaceAll(regexps.addressForGoogleMaps, '+');

        window.open(`https://www.google.com/maps/dir/?api=1&
        origin=${rearangedOriginAddress}&
        destination=${rearangedDestinationAddres}&travelMode=driving`);

    }

    async function handleSearch() {
        setRegionData([]);
        setPageLoading(true);

        const { validatedForm, isValid } = validateForm(dataForm);

        setDataForm({
            ...dataForm,
            ...validatedForm
        });

        if (!isValid && validatedForm.specialty.options.length > 0) {
            setPageLoading(false);
            setTimeout(() => {
                const firstElementWithError = document.querySelector('.error');

                if (firstElementWithError) {
                    firstElementWithError.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);

            return;
        }

        const payload = {
            carteirinha: dataDadosTitular.numCarteira,
            plano: dataDadosTitular.plano.nome,
            rede: "Rede Médica",
            descricaoPerfil: "BENEFICIARIO",
            codigoEspecialidade: dataForm.specialty.value,
            especialidade: dataForm.specialty.lookup,
            descricaoAtendimento: dataForm.service.lookup,
            tipoAtendimento: dataForm.service.value,
            tipoRegiao: "1",
            cidade: dataForm.city.lookup,
            uf: dataForm.uf.lookup,
            codigoCidade: dataForm.city.value
        };

        let response = [];

        try {
            response = await searchAssistencialNetworkList(payload);
        } catch (error) {
            setPageLoading(false);
            setShowWarningModal(true);
            setModalMessage(
                'Ocorreu um erro na pesquisa. Por gentileza, entre em contato com o adminstrador do sistema.'
            );
        } finally {
            setRegionData([...response]);
            setInitialRegionData([...response]);

            const bairros = [];
            const usedCodes = new Set();

            response.forEach((element) => {
                let codigo;
                do {
                    codigo = Math.floor(Math.random() * 1000) + 1;
                } while (usedCodes.has(codigo));
                usedCodes.add(codigo);

                bairros.push({
                    codigo,
                    nome: element.bairro
                });
            });

            const filteredBairros = bairros.filter((item, index, self) =>
                index === self.findIndex((t) => t.nome === item.nome)
            );

            const districtsValues = {
                ...dataForm,
                districts: {
                    ...dataForm.districts,
                    options: filteredBairros
                }
            }

            setDataForm({
                ...dataForm,
                ...districtsValues
            });

            setPageLoading(false);
        }
    }

    async function handleGenaretePDF() {
        setPageLoading(true);

        const commonPayload = {
            carteirinha: dataDadosTitular.numCarteira,
            descricaoPerfil: "BENEFICIARIO",
        };

        let response = [];

        try {
            if (showDetailModal) {
                const provider = {
                    ...commonPayload,
                    idPrestador: detailsData[0].codigo,
                    codigoEnderecoPrestador: detailsData[0].codigoEndereco,
                };
                response = await generateProviderPDF(provider);
            } else {
                const accredited = {
                    ...commonPayload,
                    plano: dataDadosTitular.plano.nome,
                    rede: "Rede Médica",
                    codigoEspecialidade: dataForm.specialty.value,
                    especialidade: dataForm.specialty.lookup,
                    descricaoAtendimento: dataForm.service.lookup,
                    tipoAtendimento: dataForm.service.value,
                    tipoRegiao: "1",
                    cidade: dataForm.city.lookup,
                    uf: dataForm.uf.lookup,
                    codigoCidade: dataForm.city.value,
                };

                response = await generateAccreditedPDF(accredited);
            }
        } catch (error) {
            setPageLoading(false);
            setShowWarningModal(true);
            setModalMessage(
                'Ocorreu um problema ao baixar o documento. Por gentileza, entre em contato com o adminstrador do sistema.'
            );
        } finally {
            const file = window.URL.createObjectURL(response);
            downloadFile("detalhamento.pdf", file);
            setPageLoading(false);
        }

    }

    return (
        <PageContainer>
            <StepProgress steps={steps.pesquisaRede} activeStep={2} />
            <Accordion title="Pesquisa Rede Assistencial" hasCollapse={false}>
                <FormContainer>
                    <Select field={{ ...dataForm.network }} onChange={handleSelectChange} />
                    <Select field={{ ...dataForm.healthPlan }} onChange={handleSelectChange} />
                    <Select field={{ ...dataForm.service }} onChange={handleSelectChange} />
                    {indicadorRequerEspecialidade !== 'N' && (
                        <Select field={{ ...dataForm.specialty }} onChange={handleSelectChange} />
                    )}
                    <Select field={{ ...dataForm.uf }} onChange={handleSelectChange} />
                    <Select field={{ ...dataForm.city }} onChange={handleSelectChange} />
                </FormContainer>
            </Accordion>

            <ContainerButton>
                <Button id="backStep" type="secondary" onClick={() => history.goBack()}>
                    Voltar
                </Button>

                <Button id="continueStep" type="primary" onClick={handleSearch}>
                    Pesquisar
                </Button>
            </ContainerButton>
            {regionData.length > 0 && (
                <SearchedContainer>
                    <FilterBox>
                        <FilterIcons>
                            <Icon style={{ cursor: "pointer" }} name="print" size={30} color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                            <p className='icon-label' style={{ cursor: "pointer" }} onClick={handleGenaretePDF}>Imprimir</p>
                        </FilterIcons>
                        <Divider />
                        <p className='title'>Filtre o resultado</p>

                        <CheckboxGroup field={dataForm.districts} columns={4} onChange={handleSelectChange} />
                        <FilterButton>
                            <span onClick={handleFilterRegions}>Filtrar</span>
                        </FilterButton>
                    </FilterBox>
                    <StyledTabs activeKey={activeTab} onChange={setActiveTab} defaultActiveKey="1">
                        <StyledTabPane tab="Lista das Unidades" key="1">
                            {
                                regionData.map((element, index) =>
                                    <UnitiesBox key={index}>
                                        <StyledTittle>{element.nome}</StyledTittle>
                                        <Divider />
                                        <UnitiesIcons>
                                            <div className='info-icons'>
                                                <Icon name="map" size={40} color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                                                <span>{element.logradouro} - {element.bairro} - {element.cidade}/{element.estado} - CEP: {element.cep}</span>
                                            </div>
                                            <div className='info-icons'>
                                                <Icon name="info" size={40} color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                                                <span>{element.tipoEstablecimento}</span>
                                            </div>
                                            <div className='info-icons'>
                                                <Icon style={{ width: "40px" }} name="phoneintalk" size={40} color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                                                <span>Telefone: {element.telefone}</span>
                                            </div>
                                        </UnitiesIcons>
                                        <ContainerDetailButton>
                                            <Button type="secondary" id="details" onClick={() => handleShowDetails(element)}>Detalhes</Button>
                                        </ContainerDetailButton>
                                    </UnitiesBox>
                                )
                            }
                        </StyledTabPane>
                        <StyledTabPane tab="Mapa das unidades" key="2">
                            <div style={{ width: "112%", height: "400px", marginLeft: "-50px" }}>
                                <MapContainer regionData={regionData} defaultMapsProps={defaultMapsProps} />
                            </div>
                        </StyledTabPane>
                    </StyledTabs>
                </SearchedContainer>
            )}
            <DetailModal
                title="Detalhe unidade"
                visible={showDetailModal}
                onCancel={() => setShowDetailModal(false) && setDetaisData([])}
                footer={null}
                modalSize='lg'
            >
                <StyledModalBody>
                    {
                        detailsData.map((element, index) =>
                            <StyledDetailsContent key={index}>
                                <Icon style={{ cursor: "pointer" }} name="print" size={30} color={contrastTheme ? '#FFF333' : '#EC6E0C'} onClick={handleGenaretePDF} />
                                <StyledTittle>{element.nome}</StyledTittle>
                                <UnitiesIcons style={{ marginLeft: "-13px" }}>
                                    <div className='info-icons'>
                                        <Icon name="map" size={40} color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                                        <span>{element.logradouro} - {element.bairro} - {element.cidade}/{element.estado} - CEP: {element.cep}</span>
                                    </div>
                                    <div className='info-icons'>
                                        <Icon style={{ width: "40px" }} name="phoneintalk" size={40} color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                                        <span>Telefone: {element.telefone}</span>
                                    </div>
                                </UnitiesIcons>
                                <StyledInfos>
                                    <span>Razão social:</span>
                                    <span className='result'>{element.razaoSocial}</span>
                                </StyledInfos>
                                <StyledInfos>
                                    <span>CNPJ/CPF:</span>
                                    <span className='result'>{element.cnpj}</span>
                                </StyledInfos>
                                <StyledInfos>
                                    <span>CNES:</span>
                                    <span className='result'>{element.cnes}</span>
                                </StyledInfos>
                                <StyledInfos>
                                    <span>Tipo de estabelecimento:</span>
                                    <span className='result'>{element.tipoEstablecimento}</span>
                                </StyledInfos>
                                <StyledInfos>
                                    <span>Website:</span>
                                    <span className='result'>{element.site}</span>
                                </StyledInfos>
                                <StyledInfos>
                                    <span>Especialidades contratadas</span>
                                    {
                                        especialidadesContratadas.map((elemento, indice) =>
                                            <span key={indice} className='result'>{elemento.descricaoEspecialidade}</span>
                                        )
                                    }
                                </StyledInfos>
                                <TableContainer>
                                    <span>Planos contratados:</span>
                                    <DataTableMui
                                        data={dataTable}
                                        loading={loading}
                                        columns={columnsHead}
                                        emptyMessage="Informamos que não foi encontrado nenhum dado a ser apresentado com os filtros preenchidos."
                                        alreadySearched={alreadySearched}
                                    />
                                </TableContainer>
                            </StyledDetailsContent>
                        )
                    }
                    <StyledDetailsRoute>
                        <StyledTittle>Como chegar:</StyledTittle>
                        <div className="form">
                            <Input field={{ ...dataForm.origin }} onChange={handleSelectChange} />
                            <Button type="primary" id="route" onClick={handleMapDestination}>Rota</Button>
                        </div>
                        <div className="map">
                            <MapContainer regionData={detailsData} defaultMapsProps={defaultMapsProps} style={{
                                position: "absolute",
                                marginTop: "20px",
                                paddingTop: "20px",
                                width: "60%",
                                height: "30%",
                            }} />
                        </div>
                    </StyledDetailsRoute>
                </StyledModalBody>
            </DetailModal>
            <PageLoader loading={pageLoading} />
            <Modal
                title="Atenção"
                subtitle={modalMessage}
                visible={showWarningModal}
                onCancel={() => setShowWarningModal(false)}
                footer={null}
            >
                <Button
                    type="primary"
                    onClick={() => {
                        setShowWarningModal(false);
                    }}
                >
                    Entendi
                </Button>
            </Modal>
        </PageContainer>
    );
}

export default SelecionarRedeAssistencial;
